import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

export const INCENTIVES_ROUTE_ELEMENT_ID = 'incentivesRoute'

const IncentivesRoute = lazyWithRetries(() => import('.'))
const IncentiveRoute = lazyWithRetries(() => import('./incentive'))
const ConfigureIncentiveRoute = lazyWithRetries(() => import('./configureIncentive'))
const DuplicateIncentiveRoute = lazyWithRetries(() => import('./duplicateIncentive'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.manageIncentives(),
    element: (
      <StandardPageLayout
        maxWidth={1440}
        title={<T _str="Incentives" />}
        elementId={INCENTIVES_ROUTE_ELEMENT_ID}>
        <Suspense fallback={<RouteLoading />}>
          <IncentivesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.manageIncentive(':id', ':tab?'),
    element: (
      <StandardPageLayout maxWidth={1440} elementId="incentiveRoute">
        <Suspense fallback={<RouteLoading />}>
          <IncentiveRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.configureIncentive(':id?'),
    element: (
      <StandardPageLayout maxWidth={600} elementId="configureIncentiveRoute">
        <Suspense fallback={<RouteLoading />}>
          <ConfigureIncentiveRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.duplicateIncentive(':id'),
    element: (
      <StandardPageLayout maxWidth={600} elementId="duplicateIncentiveRoute">
        <Suspense fallback={<RouteLoading />}>
          <DuplicateIncentiveRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
